<ng-container *transloco="let t">
  <app-page-template>
    <section class="upper-section">
      <div class="upper-section-background image-fade-in" [@fadeInAnimation]="'in'"></div>
      <div class="content-wrapper d-block d-md-flex justify-content-center align-items-center px-4">
        <app-form-card>
          <h1 class="text-uppercase pb-4">{{t('change.password')}}</h1>
          <form [formGroup]="inputForm">
            <div class="form-floating mb-3">
              <input type="password" id="password" class="form-control" formControlName="password" name="password" />
              <label for="password">{{t('app.common.password')}}</label>
            </div>
            <div class="form-floating">

              <input type="password" id="confirmPassword" class="form-control" formControlName="confirmPassword"
                name="confirmPassword" minlength="6" />
              <label for="confirmPassword">{{t('app.common.confirm.password')}}</label>
            </div>
            @if(changePasswordOnRecoveryComponentState ===
            changePasswordOnRecoveryComponentStateType.VERIFICATION_LINK_EXPIRED){
            <div class="pt-4">
              {{t('change.password.on.recovery.error.verification')}}
            </div>
            }
            @if(changePasswordOnRecoveryComponentState ===
            changePasswordOnRecoveryComponentStateType.PASSWORDS_DO_NOT_MATCH){
            <div class="pt-4">
              {{t('change.password.on.recovery.error.password')}}
            </div>
            }
            <div class="pt-4">
              <app-button (click)="onSubmit()" [label]="t('app.common.submit')"
                [btnClass]="'btn-primary-red btn-large'" />
            </div>
          </form>
        </app-form-card>
      </div>
    </section>
  </app-page-template>
</ng-container>